import React from 'react'
import {TfiAngleLeft, TfiAngleRight} from "react-icons/tfi";


export function Paginator({next, previous, currentPage, totalPages, hasNext, hasPrevious}) {
    return <div className="flex justify-end items-center font-bold py-3">
        <div className="flex space-x-16 bg-white p-2">
            <button onClick={previous}
                    className="flex space-x-2 items-center disabled:text-gray-400 text-sm" disabled={!hasPrevious}>
                <TfiAngleLeft/><span>Previous</span></button>

            <span
                className="text-slate-600 font-normal text-sm">Page {totalPages === 0 ? 0 : currentPage} of {totalPages}</span>
            <button onClick={next} className="flex space-x-2 items-center disabled:text-gray-400 text-sm"
                    disabled={!hasNext}><span>Next</span> <TfiAngleRight/></button>
        </div>
    </div>;
}
